export const appointmentAr = {
  "Matin": "الصباح",
  "Soir": "المساء",
  "Lundi": "الاثنين",
  "Mardi": "الثلاثاء",
  "Mercredi": "الأربعاء",
  "Jeudi": "الخميس",
  "Vendredi": "الجمعة",
  "Samedi": "السبت",
  "Dimanche": "الأحد",
  "Rendez-vous DR.": "مواعيد د.",

  "Montée": "بداية الدوام",
  "Descente": "نهاية الدوام",
  "Temps": "الوقت",
  "NBS.SN": "عدد الجلسات",
  "Nombre de seance": "عدد الجلسات",
  "Jour du travail": "أيام العمل",
  "Pause": "استراحة",
  "Filter": "تغيير",
  "Supprimer le rendez-vous": "حذف الموعد",
  "Supprimer l'acte": "حذف العمل",

 
  // Server side 

  "Le rendez-vous existe deja": "الموعد موجود بالفعل",
  "Le patient est obligatoire": "مطلوب إضافة مريض",
  "Date de rendez-vous est obligatoire": "تاريخ الموعد إلزامي",
  "Heure de rendez-vous est obligatoire": "وقت الموعد مطلوب",
  "Vous etes obligé de choisir un jour.": "عليك أن تختار يوما.",
  "deja existe": "موجود أصلا",
  "le nom est obligatoire": "الاسم مطلوب",
  "Choisir un temps partiel": "اختر بدوام جزئي",
  "Donner la date du debut du : matin": "إعطاء تاريخ البدء: صباحا",
  "Donner la date du debut du : soir": "إعطاء تاريخ البدء: مساءاً",
  "Donner la date du descente du : matin": "أعط تاريخ النزول: صباحا",
  "Donner la date du descente du : soir": "أعط تاريخ النزول: مساءاً",

  "Démain": "غداً",
  "Aprés Démain": "بعد غد",
  "Hier": "أمس",
  "Avant-hier": "قبل الأمس",
  "Aprés": "بعد",
  "Avant": "قبل",
  "jours": "أيام",
  

}
